module.exports = __webpack_public_path__ + "static/img/签约江海大智能制造产业学院.4722f517.jpg";